"use client"

import { useState } from "react"
import { Button, Snackbar } from "@mui/material"

const RemoveDialog = ({ open, endpoint, itemId, onResult }) => {
  const [loading, setLoading] = useState(false)

  const handleRemove = async () => {
    if (loading) return

    setLoading(true)
    try {
      const response = await fetch(`/api/${endpoint}/${itemId}`, {
        method: "DELETE",
      })

      if (response.ok) {
        onResult(true)
      } else {
        throw new Error(await response.text())
      }
    } catch (error) {
      console.error("Erro ao remover:", error)
      onResult(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => onResult(false)}
      message="Confirmar remoção?"
      sx={{
        zIndex: 1400,
        bottom: { xs: 80, md: 24 },
        pointerEvents: "auto",
      }}
      action={
        <Button
          size="small"
          color="error"
          onClick={handleRemove}
          disabled={loading}
          sx={{
            height: "auto",
            marginTop: 0,
            marginBottom: 0,

            pointerEvents: "auto",
            zIndex: 1,
          }}
        >
          {loading ? "Removendo..." : "Remover"}
        </Button>
      }
    />
  )
}

export default RemoveDialog